import dayjs, { Dayjs } from 'dayjs';

// Import all locales
import 'dayjs/locale/ar-sa';
import 'dayjs/locale/en';
import 'dayjs/locale/fr';
// ... import all other locales

// Set the locale globally
dayjs.locale('en'); // You can set your preferred default locale here

export default dayjs as typeof dayjs & {
     (date?: dayjs.ConfigType): Dayjs;
};
